import React, { Component, Fragment } from 'react'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    title: 'Rights',
    dataIndex: 'rights',
    sorter: (a, b) => a.rights.localeCompare(b.rights)
  },
  {
    title: 'Country',
    dataIndex: 'country',
    // render: (name, row) => (
    //   <Link to={ROUTES.OPERATOR_EDIT.replace(':clientId', row.username)}>
    //     {name}
    //   </Link>
    // ),
    sorter: (a, b) => a.country.localeCompare(b.country)
  },
  {
    title: 'Clients',
    dataIndex: 'clients',
    sorter: (a, b) => a.clients.localeCompare(b.clients)
  }
]

const ListView = ({ profile }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {profile.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {profile.length} profile
      </PageContentUnderTitle>
    )}
    <Table dataSource={profile} columns={columns} pagination={false} rowKey="name" />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/profile/profile-list/components/list-view/index.js